module.exports = __webpack_public_path__ + "cc9e02cd.svg";